import React from 'react';
import { FaEnvelope, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer mt-2">
      {/* Main Footer Content */}
      <div className="footer-main py-4">
        <div className="container">
          <div className="row g-4">
            {/* Column 1: Contact & Social */}
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="footer-section">
                <h5 className="footer-heading">Connect With Us</h5>
                <div className="footer-content">
                  <a href="mailto:technix7.0team@gmail.com" className="footer-link">
                    <FaEnvelope className="me-2" /> technix7.0team@gmail.com
                  </a>
                  <a 
                    href="https://www.instagram.com/technix7.0?igsh=MWRhamU5Mnp0eXVreg==" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="footer-link mt-2"
                  >
                    <FaInstagram className="me-2" /> Technix 7.0
                  </a>
                </div>
              </div>
            </div>

            {/* Column 2: Designer Info
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="footer-section">
                <h5 className="footer-heading">Website Design</h5>
                <div className="footer-content">
                  <p className="mb-2">Nachiket Hegde</p>
                  <a href="tel:+911234567890" className="footer-link">
                    <FaPhone className="me-2" /> +91 9353154253
                  </a>
                </div>
              </div>
            </div> */}

            {/* Column 3: Location Map */}
            <div className="col-md-4">
              <div className="footer-section">
                <h5 className="footer-heading">College Location</h5>
                <div className="footer-map">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.446884438963!2d77.56681777484431!3d13.134187587196283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae18a5c54ece35%3A0x49c4c47a68a60b9c!2sBMS%20Institute%20of%20Technology%20and%20Management!5e0!3m2!1sen!2sin!4v1763835006354!5m2!1sen!2sin"
                    width="100%" 
                    height="200" 
                    style={{ border: 0, borderRadius: '8px' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="College Location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-copyright py-3">
        <div className="container text-center">
          <small>&copy; {new Date().getFullYear()} BMSIT&M. All Rights Reserved.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
